import { useEffect, useState } from "react";
import { MagnifyingGlass, Check } from "@phosphor-icons/react";
import API from "../../../lib/api";
import { Input } from "../../ui/input";

/** Search-as-you-type tenant picker for the console. `excludeModuleId` greys tenants that already have that module. */
export function TenantPicker({ value, onChange, excludeModuleId, testId = "bespoke-tenant-picker" }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    const t = setTimeout(() => {
      API.get("/platform/bespoke/tenants", { params: { q } }).then(({ data }) => alive && setRows(data)).catch(() => alive && setRows([])).finally(() => alive && setLoading(false));
    }, 250);
    return () => { alive = false; clearTimeout(t); };
  }, [q]);

  return (
    <div data-testid={testId}>
      <div className="relative">
        <MagnifyingGlass size={14} className="absolute left-2.5 top-2.5 text-muted-foreground" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search tenants by name or slug" className="pl-8" data-testid={`${testId}-search`} />
      </div>
      <div className="mt-2 max-h-56 overflow-y-auto rounded-md border border-border divide-y divide-border">
        {loading && rows.length === 0 && <p className="text-xs text-muted-foreground p-3">Searching…</p>}
        {!loading && rows.length === 0 && <p className="text-xs text-muted-foreground p-3">No tenants match.</p>}
        {rows.map((t) => {
          const has = excludeModuleId && (t.module_ids || []).includes(excludeModuleId);
          const selected = value?.id === t.id;
          return (
            <button key={t.id} type="button" disabled={has} onClick={() => onChange(t)}
              className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors ${selected ? "bg-primary/10" : "hover:bg-muted"} disabled:opacity-50`} data-testid={`${testId}-row-${t.slug}`}>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{t.name}{t.is_sandbox ? <span className="ml-1 text-[10px] text-muted-foreground">sandbox</span> : null}</p>
                <p className="text-[10px] text-muted-foreground truncate">/{t.slug} · {(t.plan || "").replace(/_/g, " ")} · {t.billing_mode === "invoiced" ? "invoiced" : t.subscription_status || "—"}{has ? " · already has this module" : ""}</p>
              </div>
              {selected && <Check size={14} className="text-primary" weight="bold" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
